import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import LavorisService from "../services/LavorisService";

export function useFetchOne<T>(
  resource: string,
  id?: string | null,
  onFetched?: (item: T) => void,
): T | undefined {
  const [rowData, setRowData] = useState<T>();
  const [searchParams] = useSearchParams();
  const LavorisInstance = LavorisService.getInstance();
  const rowId = id || (searchParams.get("rowId") as string);

  useEffect(() => {
    LavorisInstance.Common.getOne<T>(resource, rowId)
      .then((res) => {
        setRowData(res);
        onFetched && onFetched(res);
      })
      .catch(console.error);
    // eslint-disable-next-line
  }, [rowId]);

  return rowData;
}

export function useFetchOneWithStatus<T>(
  resource: string,
  id?: string | null,
  onFetched?: (item: T) => void,
): {status: FetchStatusTypes, data: T | undefined} {
  const [rowData, setRowData] = useState<T>();
  const [searchParams] = useSearchParams();
  const LavorisInstance = LavorisService.getInstance();
  const rowId = id || (searchParams.get("rowId") as string);
  const [status, setStatus] = useState<FetchStatusTypes>('IDLE');

  useEffect(() => {
    setStatus('FETCHING');
    LavorisInstance.Common.getOne<T>(resource, rowId)
      .then((res) => {
        setRowData(res);
        setStatus('FETCHED');
        onFetched && onFetched(res);
      })
      .catch((error) => {
        const { statusCode } = error.response.data;

        let errResponse: FetchStatusTypes = 'UNKNOWN';
        if (statusCode === 400) errResponse = 'UNKNOWN';
        if (statusCode === 404) errResponse = 'NOT_FOUND';
        if (statusCode === 409) errResponse = 'CONFLICT';

        setStatus(errResponse);
      });
    // eslint-disable-next-line
  }, [rowId]);

  return ({ status, data: rowData });
}
